import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useRef } from 'react';
const useIsometricEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
function useValueRef(value) {
  const $ = _c(3);
  const ref = useRef(value);
  let t0;
  let t1;
  if ($[0] !== value) {
    t0 = () => {
      ref.current = value;
    };
    t1 = [value];
    $[0] = value;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useIsometricEffect(t0, t1);
  return ref;
}
export default useValueRef;